import React from 'react';
import styled from 'styled-components';
import { COLOR } from '../../../constant-styles';

export const CarrouselContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	position: relative;
	min-height: 30vh;
	//overflow: hidden;
`;

export const CarImagesContainer = styled.div`
	width: 100vw;
	height: 100%;
	position: relative;
	z-index: 0;
	transform-origin: center center;
	transform: scale(1.3);
`;

export const CarImageContainer = styled.div`
	width: 100vw;
	height: 100%;
	position: relative;
	z-index: 0;
	transform-origin: center center;
	transform: scale(1.3);
	display: flex;
	justify-content: center;

	@media screen and (min-width: 1199px) {
		margin-left: 10vw;
	}
	@media screen and (min-width: 1200px) {
		margin-right: 10vw;
	}
`;

export const StyledCarImagesRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
	height: 100%;
	white-space: nowrap;
	pointer-events: none;
`;

export const StyledCarImage = styled.img`
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	width: clamp(150px, 42vw, 925px);

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		height: 265px;
	}
`;
export const ControlsContainer = styled.div`
	position: absolute;
	bottom: 0;
	left: 40%;
	transform: translateX(-50%);
	z-index: 10;
	pointer-events: auto;

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		left: 50%;
	}
`;

export const PauseIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
		<rect x="2" y="2" width="2.5" height="8" rx="0.5" fill="white" />
		<rect x="7.5" y="2" width="2.5" height="8" rx="0.5" fill="white" />
	</svg>
);

export const PlayIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 2L10 6L3 10V2Z" fill="white" />
	</svg>
);

export const IconWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${COLOR.BLACK_25};
	border-radius: 50%;
	width: 22px;
	height: 22px;
	margin-right: 4px;
`;

export const ModelCarrouselLayout = styled.div<{ hasOneCarline: boolean }>`
	//overflow: hidden;
	position: absolute;
	right: 0;

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		top: ${(props) => (props.hasOneCarline ? '0' : '14vh')};
		position: ${(props) => props.hasOneCarline && 'unset'};
		//height: ${(props) => props.hasOneCarline && '25vh'};
		align-content: ${(props) => props.hasOneCarline && 'center'};
		margin-bottom: ${(props) => props.hasOneCarline && '40px'};
	}

	@media screen and (min-width: 1200px) {
		height: 100%;
		align-content: center;
	}

	max-height: 330px;
`;
